import { Component, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { NetworkService } from "src/app/services/network.service";

@Component({
  selector: "app-condiment",
  templateUrl: "./condiment.component.html",
  styleUrls: ["./condiment.component.scss"],
})
export class CondimentComponent implements OnInit, OnDestroy {
  @Input() heading: string;
  @Input() description: string;
  @Input() img: string;
  @Input() amount = 0;
  @Input() selected = false;
  @Input() disabled = false;

  @Output() condimentClick = new EventEmitter();

  networkStatusStream;
  isOnline: boolean;

  constructor(private network: NetworkService) {
    this.networkStatusStream = this.network.appIsOnline$.subscribe(online => {
      if (online) {
        this.isOnline = true;
      } else {
        this.isOnline = false;
      }
    });
  }

  ngOnInit() {}

  onCondimentClick(action: string) {
    if (!this.disabled) {
      /* this.selected = !this.selected; */
      this.condimentClick.emit(action);
    }
  }

  ngOnDestroy() {
    this.networkStatusStream.unsubscribe();
  }
}
